<normal-login-btn [name]="title" [active]="active" (btnClicked)="submitEvent.emit($event)"></normal-login-btn>
<div class="border-t border-gray-200 mt-8 mb-6"></div>
